import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiService } from './../api.service';
import { Candidate } from './candidates.service';

@Injectable({
  providedIn: 'root'
})
export class RestrictedListService {
  get$ = this.api.get<Candidate[]>({
    path: 'recruiter/restricted'
  });

  save = (candidates: any) =>
    this.api
      .post<void>({
        path: 'recruiter/restricted',
        body: { candidates }
      })
      .pipe(map(result => ({ ...result, candidates })));

  constructor(private api: ApiService) {}
}
